import React from "react";

// Official AWS Simple Storage Service (S3) icon
function S3Icon({ className = "w-8 h-8" }) {
    return (
        <svg 
            className={className} 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="#569A31"
        >
            <path d="M12.006 13.918L24 10.375l-.014 4.568-11.98 3.541-11.992-3.541v-4.568l11.992 3.543zm.014-9.696L0 7.765l12.02 3.544L24 7.766l-11.98-3.544zM0 13.782l12.006 3.543 11.98-3.543v4.569L12.006 21.89 0 18.35v-4.568z" />
        </svg>
    );
}

export default S3Icon;
